(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["split-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  class SplitSlideshow {
    constructor(el) {
      this.el       = el;
      this.slides   = [...el.querySelectorAll('[data-slide]')];
      this.allDots  = [...el.querySelectorAll('[data-dot]')];
      this.total    = this.slides.length;
      this.current  = 0;
      this.busy     = false;
      this.autoplay = el.dataset.autoplay === 'true';
      this.speed    = parseInt(el.dataset.speed, 10) || 5000;
      this.timer    = null;

      if (this.total < 2) return;

      /* Inject speed as CSS var so progress bar knows its duration */
      el.style.setProperty('--ss-speed', this.speed + 'ms');

      /* ── Buttons (delegated — works across all slides) ── */
      el.addEventListener('click', e => {
        if (e.target.closest('[data-prev]')) { e.preventDefault(); this.prev(); }
        if (e.target.closest('[data-next]')) { e.preventDefault(); this.next(); }
      });

      this.allDots.forEach(dot =>
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.dot, 10)))
      );

      /* ── Touch / Swipe ── */
      let sx = 0, sy = 0, moved = false;

      el.addEventListener('touchstart', e => {
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
        moved = false;
      }, { passive: true });

      el.addEventListener('touchmove', e => {
        const dx = Math.abs(e.touches[0].clientX - sx);
        const dy = Math.abs(e.touches[0].clientY - sy);
        if (dx > dy && dx > 8) moved = true;
      }, { passive: true });

      el.addEventListener('touchend', e => {
        if (!moved) return;
        const diff = e.changedTouches[0].clientX - sx;
        if (Math.abs(diff) > 44) diff < 0 ? this.next() : this.prev();
      }, { passive: true });

      /* ── Keyboard ── */
      el.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft')  { e.preventDefault(); this.prev(); }
        if (e.key === 'ArrowRight') { e.preventDefault(); this.next(); }
      });

      /* ── Autoplay ── */
      if (this.autoplay) {
        this._startAuto();
        requestAnimationFrame(() => this._tickProgress(0));
      }

      /* Pause + clear on hover / focus */
      const pause = () => { this._stopAuto(); this._clearProgress(); };
      const resume = () => {
        if (!this.autoplay) return;
        this._startAuto();
        this._tickProgress(this.current);
      };

      /* Pause when tab hidden */
      document.addEventListener('visibilitychange', () =>
        document.hidden ? pause() : resume()
      );
    }

    goTo(index) {
      if (this.busy || index === this.current || index < 0 || index >= this.total) return;
      this.busy = true;

      /* Stop progress animation on outgoing dot */
      this._clearProgress();

      /* Swap slides */
      this.slides[this.current].classList.remove('is-active');
      this.slides[this.current].setAttribute('aria-hidden', 'true');
      this.slides[index].classList.add('is-active');
      this.slides[index].setAttribute('aria-hidden', 'false');

      /* Sync all dot instances */
      this.allDots.forEach(dot => {
        const active = parseInt(dot.dataset.dot, 10) === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });

      this.current = index;

      /* Restart progress on new dot if autoplay is running */
      if (this.autoplay && this.timer) {
        requestAnimationFrame(() => this._tickProgress(index));
      }

      /* Unlock after transition completes (same timing on all breakpoints) */
      clearTimeout(this._lock);
      this._lock = setTimeout(() => { this.busy = false; }, 870);
    }

    next() { this.goTo((this.current + 1) % this.total); }
    prev() { this.goTo((this.current - 1 + this.total) % this.total); }

    /* Restart the CSS animation on the active dot — forces reflow to reset */
    _tickProgress(index) {
      this.allDots.forEach(dot => {
        if (parseInt(dot.dataset.dot, 10) !== index) return;
        dot.classList.remove('is-playing');
        void dot.offsetWidth;          /* reflow — resets animation */
        dot.classList.add('is-playing');
      });
    }

    _clearProgress() {
      this.allDots.forEach(dot => dot.classList.remove('is-playing'));
    }

    _startAuto() {
      this._stopAuto();
      this.timer = setInterval(() => this.next(), this.speed);
    }
    _stopAuto() {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  /* ── Init ── */
  function init() {
    document.querySelectorAll('.ss[data-section-id]').forEach(el => {
      if (!el._ss) el._ss = new SplitSlideshow(el);
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

  /* Shopify theme editor */
  document.addEventListener('shopify:section:load', e => {
    const el = e.target.querySelector('.ss[data-section-id]');
    if (el && !el._ss) el._ss = new SplitSlideshow(el);
  });
  document.addEventListener('shopify:section:reorder', init);

})();

  } catch(e) { console.error(e); }
})();
})();
